import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { InputProps } from '../types';
import { Input } from '../Input';

export interface FormInputProps extends InputProps {
	name: string;
	InputComponent?: (props: InputProps) => React.ReactNode;
	transform?: (value: string) => string;
}

export const FormInput = ({
	name,
	optional,
	InputComponent = Input,
	defaultValue,
	disabled,
	transform,
	...inputProps
}: FormInputProps) => {
	const { control } = useFormContext();

	return (
		<Controller
			name={name}
			control={control}
			defaultValue={defaultValue}
			disabled={disabled}
			render={({ field: { onChange, onBlur, value, disabled }, fieldState: { error } }) => (
				<InputComponent
					{...inputProps}
					value={value}
					onChangeText={transform ? (val) => onChange(transform(val)) : onChange}
					onBlur={onBlur}
					disabled={disabled}
					error={!!error}
					errors={error?.message ? [error?.message] : undefined}
					optional={optional}
				/>
			)}
		/>
	);
};
